import { useEffect } from 'react';

import { type ShareState, useChartMenuContext } from '../ChartMenuContext';

/**
 * Registers the chart's plot-share data (type + props + data) with the
 * chart-menu, powering PPT export of an individual plot. Shared-report
 * snapshot capture is separate and handled by the `withShareCapture` HOC on
 * each replots export.
 */
export const usePlotShareData = ({
  data,
  chartType,
  chartProps,
}: ShareState) => {
  const { setShareData } = useChartMenuContext();
  const stringifiedChartProps = JSON.stringify(chartProps);

  useEffect(() => {
    setShareData({
      chartType,
      chartProps: JSON.parse(stringifiedChartProps),
      data,
    });
  }, [stringifiedChartProps, data, chartType, setShareData]);
};
